import { useCallback } from 'react';
import {
  Toast,
  ToastTitle,
  useToastController,
  type ToastIntent,
} from '@fluentui/react-components';
import { useAppDispatch } from '@store/hooks';
import { addNotification } from '@store/slices/notificationsSlice';

export const APP_TOASTER_ID = 'app-toaster';

export interface ShowToastOptions {
  message: string;
  intent: ToastIntent;
  timeout?: number;
}

export interface UseGlobalToastResult {
  showToast: (options: ShowToastOptions) => void;
}

export function useGlobalToast(): UseGlobalToastResult {
  const { dispatchToast } = useToastController(APP_TOASTER_ID);
  const dispatch = useAppDispatch();

  const showToast = useCallback(
    ({ message, intent, timeout = 3000 }: ShowToastOptions) => {
      if (!message || message.trim().length === 0) {
        return;
      }
      dispatchToast(
        <Toast>
          <ToastTitle>{message}</ToastTitle>
        </Toast>,
        { intent, timeout }
      );
      dispatch(addNotification({ message, intent }));
    },
    [dispatchToast, dispatch]
  );

  return { showToast };
}
